import { render } from "./ProblemSection.vue?vue&type=template&id=e5aaec5a&scoped=true"
import script from "./ProblemSection.vue?vue&type=script&lang=js"
export * from "./ProblemSection.vue?vue&type=script&lang=js"

import "./ProblemSection.vue?vue&type=style&index=0&id=e5aaec5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5aaec5a"]])

export default __exports__